import React from 'react';
import ATSResumePdf from './ATSResumePdf';
export default function ATSClassicPdf(props) { return <ATSResumePdf {...props} variant="classic" />; }